var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.9 124.2",
    style: {
      enableBackground: "new 0 0 100.9 124.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1896C2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.1,49.4c-0.8,0.6-0.9,1.8-0.3,2.6c12.3,15.3,18.8,27.6,18.8,35.5c0,18.3-14.9,33.2-33.2,33.2 s-33.2-14.9-33.2-33.2c0-16.3,26.9-45.3,33.2-51.8c1.8,1.9,5.3,5.6,9.3,10.3c0.7,0.8,1.8,0.9,2.6,0.2s0.9-1.8,0.2-2.6 c-6-6.9-10.7-11.7-10.8-11.8c-0.7-0.7-1.9-0.7-2.6,0c-1.5,1.5-35.5,35.9-35.5,55.7c0,20.3,16.5,36.8,36.8,36.8 c20.3,0,36.8-16.5,36.8-36.8c0-8.9-6.6-21.6-19.6-37.8C67.1,48.9,65.9,48.7,65.1,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.8,0.5c-0.7-0.7-1.8-0.7-2.5,0c-0.2,0.2-4,3.8-7.9,8.6c-5.4,6.7-8.2,12-8.2,16c0,9.6,7.8,17.4,17.4,17.4 c9.6,0,17.4-7.8,17.4-17.4c0-4-2.8-9.4-8.2-16.1C88.8,4.3,84.9,0.7,84.8,0.5z M83.5,38.9c-7.6,0-13.7-6.2-13.7-13.7 c0-5.8,9-16,13.7-20.8c4.8,4.8,13.7,15,13.7,20.8C97.3,32.8,91.1,38.9,83.5,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.8,25.2c0-4-2.8-9.4-8.2-16.1c-3.9-4.8-7.8-8.5-7.9-8.6c-0.7-0.7-1.8-0.7-2.5,0c-0.2,0.2-4,3.8-7.9,8.6 C2.8,15.8,0,21.2,0,25.2c0,9.6,7.8,17.4,17.4,17.4C27,42.6,34.8,34.8,34.8,25.2z M3.7,25.2c0-5.8,9-16,13.7-20.8 c4.8,4.8,13.7,15,13.7,20.8c0,7.6-6.2,13.7-13.7,13.7S3.7,32.8,3.7,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.8,72.5L37.5,95.9c-0.7,0.7-0.7,1.8-0.1,2.5c0.7,0.8,1.9,0.9,2.7,0.1l23.3-23.3c0.7-0.7,0.7-1.9,0-2.6 C62.7,71.8,61.5,71.8,60.8,72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.2,87.5c-3.1,0-5.7,2.6-5.7,5.7c0,3.1,2.6,5.7,5.7,5.7s5.7-2.6,5.7-5.7C64,90.1,61.4,87.5,58.2,87.5z  M58.2,95.3c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1s2.1,0.9,2.1,2.1C60.3,94.4,59.4,95.3,58.2,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.7,83.4c3.1,0,5.7-2.6,5.7-5.7S45.8,72,42.7,72S37,74.6,37,77.7S39.5,83.4,42.7,83.4z M42.7,75.6 c1.1,0,2.1,0.9,2.1,2.1s-0.9,2.1-2.1,2.1s-2.1-0.9-2.1-2.1S41.5,75.6,42.7,75.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/Humidity.d29e64a1f4a6c51459e088297e13895a.svg";
export { ForwardRef as ReactComponent };